import { render, staticRenderFns } from "./Localisation.vue?vue&type=template&id=57b2daa8"
import script from "./Localisation.vue?vue&type=script&lang=js"
export * from "./Localisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports